<app-question-base [question]="question" [isFirstQuestion]="isFirstQuestion">
  <div
    role="radiogroup"
    class="flex items-center flex-wrap justify-between md:content-normal md:flex-nowrap lg:justify-around mt-5"
  >
    @for (alternative of question.alternatives; track $index) {
      <label
        [for]="alternative.id"
        class="cursor-pointer relative transition-transform-slow lg:hover:scale-[1.2]"
      >
        <input
          type="radio"
          [formControl]="control"
          [id]="alternative.id"
          [name]="question.id"
          [attr.aria-checked]="
            control.value === alternative.id ? 'true' : 'false'
          "
          [attr.name]="question.id"
          [ariaLabel]="translationKeys[$index].key | translate"
          (click)="toggleSelection(alternative.id)"
          (keydown)="handleKeydown($event, alternative.id)"
          [value]="alternative.id"
          class="cursor-pointer sr-only"
        />

        <img
          src="{{ svgurls + alternative.orderNumber }}.svg"
          [class]="
            control.value && control.value !== alternative.id
              ? opacity
              : 'opacity-100'
          "
          alt="{{ translationKeys[$index].key | translate }}"
          [title]="translationKeys[$index].key | translate"
        />
      </label>
    }
  </div>
</app-question-base>
@if (control.invalid && control.touched) {
  <app-validator
    [validator]="ValidatorType.RequiredSelect"
    [question]="question"
  ></app-validator>
}
